import { useEffect, useState } from 'react'
function observeDomIfVisible(
  targetSelector: string | HTMLElement,
  callback: (target: Element, visible: boolean) => void,
  options: IntersectionObserverInit
) {
  const getAs = (): HTMLElement | null => {
    if (typeof targetSelector === 'string') {
      return document.querySelector(targetSelector)
    }
    return targetSelector
  }
  const target: HTMLElement | null = getAs()

  if (!target) {
    return () => null
  }

  const onIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      callback(entry.target, entry.isIntersecting)
    })
  }
  var observer = new IntersectionObserver(onIntersection, {
    root: null, // default is the viewport
    ...options,
  })
  observer.observe(target)

  return () => {
    observer.unobserve(target)
  }
}

export function useIsDomContentVisibleOnce(
  target: HTMLElement | string,
  options: IntersectionObserverInit = { threshold: 0.3 }
) {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    let active = true
    var putted = false
    const unbind = observeDomIfVisible(
      target,
      (_element: Element, visible: boolean) => {
        if (!active) {
          unbind()
          return
        }
        if (!putted && visible) {
          putted = true
          setVisible(true)
          unbind()
        }
      },
      options
    )
    return () => {
      active = false
      unbind()
    }
  }, [])
  return visible
}

export function useIsDomContentVisible(
  target: HTMLElement | string,
  options: IntersectionObserverInit = { threshold: 0.3 }
) {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    let active = true
    const unbind = observeDomIfVisible(
      target,
      (_element: Element, visible: boolean) => {
        if (!active) {
          unbind()
          return
        }
        setVisible(visible)
      },
      options
    )
    return () => {
      active = false
      unbind()
    }
  }, [])
  return visible
}
